import { FILE_NAME_SEPARATOR } from "@config/config";

export const buildActivationTicketFileName = (organizationName: string, gateName: string) => {
  const organization = organizationName?.replace(/ /g, FILE_NAME_SEPARATOR).toLowerCase();
  const controller = gateName.replace(/ /g, FILE_NAME_SEPARATOR).toLowerCase();

  return organization + FILE_NAME_SEPARATOR + controller;
};
